<template>
    <div class="course-list__content">
        <Draggable :draggableList="courseList" :value="courseList" v-on:input="onChange">
            <div v-for="(course, index) in localCourseList"
                 class="course-list__item"
                 :key="index"
            >
                <slot :course="course" :index="index">
                    <TotemWatchlistItem :course="course" :index="index" />
                </slot>
            </div>
        </Draggable>
    </div>
</template>

<script>
    import Draggable from '../Draggable'

    export default {
        components: { Draggable },
        props: {
            courseList: Array
        },
        computed: {
            draggableList: {
                get () {
                    return this.localCourseList
                },
                set (value) {
                    this.localCourseList = value
                    this.$emit('order-changed', value)
                }
            }
        },
        data () {
            return {
                localCourseList: []
            }
        },
        methods: {
            onChange (value) {
                this.$emit('order-changed', value)
            }
        },
        watch: {
            courseList: {
                handler (coursesList) {
                    this.localCourseList = coursesList.map(el => el)
                },
                immediate: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .course-list {
        &__content {
            @include course_list;
        }

        &__item {
            @include course_list_item;
        }
    }
</style>
